import React from 'react';

import { Skeleton } from '@mui/material';

import styles from './SortListings.module.css';

export const SortListingsSkeleton = () => {
  return (
    <div className={styles.root}>
      <Skeleton variant="text" width={260} height={24} />

      <div className={styles.sortDropdown}>
        <Skeleton variant="rounded" width={160} height={40} />
      </div>
    </div>
  );
};
